export const LIVE_CHAT = '/live-chats/viewLiveChats'
